module.exports = __webpack_public_path__ + "img/johnson_pump.0ed12441.png";